import React from 'react'
import { Center, Loader, Skeleton, Stack } from '@mantine/core'

const BTLoader = () => {
  return (
    <Stack>
      <Skeleton height={100} radius='xl'></Skeleton>
      <Center>
        <Loader size={'lg'} color='lime' />
      </Center>
      <Center>Loading Core...</Center>
    </Stack>
  )
}

export { BTLoader }
export default BTLoader
